import TreeNav from './component';
import enhance from './container';

export default enhance(TreeNav);
